import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from './IELTSCourse';
import { coherenceCohesionData, getDataForDifficulty } from './data/skills/writing/coherenceCohesion';

export default function CoherenceCohesion() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : coherenceCohesionData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
